"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorRenewalEditCarExcessWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var InfoModal_1 = require("../../../../../components/modals/InfoModal");
var ExcessExplainedRenderers_1 = require("../../../../../components/modals/renderers/ExcessExplainedRenderers");
var Types_1 = require("../../../../../Types");
var core_1 = require("@athena-portal/core");
var AnnualMotorGlassAndRepairExcessWordingGenerator_1 = require("../../../../../helpers/annual/motor/AnnualMotorGlassAndRepairExcessWordingGenerator");
var commonFunctions_1 = require("../../../../../commonFunctions");
var AnnualMotorRenewalEditCarExcessWidget = exports.AnnualMotorRenewalEditCarExcessWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorRenewalEditCarExcessWidget, _super);
    function AnnualMotorRenewalEditCarExcessWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.renderVoluntaryExcessValues = function () {
            var elements = [];
            var voluntaryExcess = _this.state.voluntaryExcess;
            for (var index = 0; index <= 500; index += 50) {
                elements.push(React.createElement("option", { selected: voluntaryExcess === index, value: index },
                    "\u00A3",
                    index));
            }
            return elements;
        };
        _this.handleSelectOnChangeEvent = function (event) {
            var voluntaryExcess = parseInt(event.target.value, 10);
            var totalExcess = _this.state.compulsoryExcess + voluntaryExcess;
            _this.setState({
                voluntaryExcess: voluntaryExcess,
                totalExcess: totalExcess
            });
            (0, commonFunctions_1.handleChanged)("vehicles[0].annualVehicleExcess.voluntaryExcess", _this.props.interaction, _this.state.initialVoluntaryExcess, voluntaryExcess);
            _this.executeNativeEvent(event);
        };
        var compulsoryExcess = _this.props.interaction.vehicles[0].annualVehicleExcess.compulsoryExcess;
        var voluntaryExcess = _this.props.interaction.vehicles[0].annualVehicleExcess.voluntaryExcess;
        var totalExcess = compulsoryExcess + voluntaryExcess;
        _this.state = {
            showPopup: false,
            compulsoryExcess: compulsoryExcess,
            voluntaryExcess: voluntaryExcess,
            initialVoluntaryExcess: voluntaryExcess,
            totalExcess: totalExcess
        };
        _this.togglePopUp = _this.togglePopUp.bind(_this);
        return _this;
    }
    AnnualMotorRenewalEditCarExcessWidget.prototype.render = function () {
        var cssClass = this.getSetting("cssClass", "");
        return (React.createElement("div", { className: "edit-car-excess-widget ".concat(cssClass) },
            React.createElement("h4", { className: "excess-heading" },
                React.createElement("div", null,
                    "Excesses that apply",
                    React.createElement(InfoModal_1.InfoModal, { className: "mb-2 ml-2", title: "Excess explained", showArrow: false }, (0, ExcessExplainedRenderers_1.renderWolfExcessExplained)(this.props.interaction.vehicles[0].annualVehicleExcess)))),
            React.createElement("div", { className: "text-center excess-section-container" }, this.renderExcessesSection())));
    };
    AnnualMotorRenewalEditCarExcessWidget.prototype.togglePopUp = function () {
        this.setState(function (state) { return ({
            showPopup: !state.showPopup
        }); });
    };
    AnnualMotorRenewalEditCarExcessWidget.prototype.renderExcessesSection = function () {
        var vehicle = this.props.interaction.vehicles[0];
        return (React.createElement("div", { className: "text-center font-weight-light annual-motor-renewal excess-section" },
            React.createElement("p", { className: "select-excess" }, "Please select your voluntary excess from the options available below"),
            React.createElement("div", { className: "excess-picker" }, this.renderExcessesPicker()),
            React.createElement("div", { className: "selected-excess-info mb-4" },
                "Your voluntary excess is added to the compulsory excess to give you the total amount you\u2019ll have to pay towards ",
                React.createElement("span", { className: "font-weight-semi-bold" }, "any claim"),
                " you make involving accidental damage, fire and theft (but ",
                React.createElement("span", { className: "font-weight-semi-bold" }, "not"),
                " glass-only claims). Your total excess applies every time you claim and for every car you\u2019re claiming on."),
            AnnualMotorGlassAndRepairExcessWordingGenerator_1.AnnualMotorGlassAndRepairExcessWordingGenerator.getGlassAndRepairExcessWording(vehicle)));
    };
    AnnualMotorRenewalEditCarExcessWidget.prototype.renderExcessesPicker = function () {
        var vehicle = this.props.interaction.vehicles[0];
        var compulsoryExcess = isNaN(vehicle.annualVehicleExcess.compulsoryExcess) ? 0 : vehicle.annualVehicleExcess.compulsoryExcess;
        var voluntaryExcess = isNaN(vehicle.annualVehicleExcess.voluntaryExcess) ? 0 : vehicle.annualVehicleExcess.voluntaryExcess;
        var totalExcess = compulsoryExcess + voluntaryExcess;
        return (React.createElement("div", null,
            React.createElement("div", { className: "voluntary-excess-picker" },
                React.createElement("div", null,
                    React.createElement("div", { className: "voluntary-excess-picker__title" },
                        React.createElement("div", null, "Compulsory"),
                        React.createElement("div", null, "excess")),
                    React.createElement("div", { className: "voluntary-excess-picker__value" },
                        "\u00A3",
                        compulsoryExcess)),
                React.createElement("div", { className: "voluntary-excess-picker__operation" }, "+"),
                React.createElement("div", null,
                    React.createElement("div", { className: "voluntary-excess-picker__title" },
                        React.createElement("div", null, "Voluntary"),
                        React.createElement("div", null, "excess")),
                    React.createElement("div", { className: "input-group" },
                        React.createElement("select", { id: this.props.question.name, className: "form-control voluntary-excess-picker__dropdown", onChange: this.handleSelectOnChangeEvent, onFocus: this.executeNativeEvent, onClick: this.executeNativeEvent, onDoubleClick: this.executeNativeEvent }, this.renderVoluntaryExcessValues()))),
                React.createElement("div", { className: "voluntary-excess-picker__operation" }, "="),
                React.createElement("div", null,
                    React.createElement("div", { className: "voluntary-excess-picker__title" },
                        React.createElement("div", null, "TOTAL"),
                        React.createElement("div", null, "excess")),
                    React.createElement("div", { className: "voluntary-excess-picker__value" },
                        "\u00A3",
                        totalExcess)))));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], AnnualMotorRenewalEditCarExcessWidget.prototype, "changelogRecorder", void 0);
    return AnnualMotorRenewalEditCarExcessWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=AnnualMotorRenewalEditCarExcessWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/renewal/car/AnnualMotorRenewalEditCarExcessWidget.js
// module id = 3194
// module chunks = 0